type Props = {
  error?: string;
  children?: React.ReactNode;
};

export default function ErrorMessage({ error, children }: Props) {
  return (
    <>
      {error && (
        <div
          className="px-4 pt-1 text-brand-primary-magenta text-xs"
          aria-label="errorMessage"
        >
          {error}
        </div>
      )}
    </>
  );
}
